<script setup lang="ts">
  import OpenTrainingExternalIndividualRow from './OpenTrainingExternalIndividualRow.vue';
  import type { useOpenTrainingExternalIndividualInstructors } from '../../model/useOpenTrainingExternalIndividualInstructors';

  defineProps<{
    form: ReturnType<typeof useOpenTrainingExternalIndividualInstructors>;
  }>();
</script>

<template>
  <OpenTrainingExternalIndividualRow
    v-for="(row, index) in form.rows.value"
    :key="row.id"
    :row="row"
    :is-first="index === 0"
    :is-add-disabled="!form.canAddMore.value"
    @update:cpf="form.setCpf(index, $event)"
    @update:profession="form.setProfession(index, $event)"
    @update:name="form.setName(index, $event)"
    @update:training-date="form.setTrainingDate(index, $event)"
    @select-curriculum-file="form.selectCurriculumFile(index, $event)"
    @remove-curriculum-file="form.removeCurriculumFile(index)"
    @add="form.addRow()"
    @remove="form.removeRow(index)"
  />
</template>
